import * as Yup from "yup";
import { COMPANY_CONTACT_REQUIRED, COMPANY_EMAIL_INVALID, COMPANY_EMAIL_REQUIRED, COMPANY_NAME_REQUIRED, EMAIL_REGEX, USER_EMAIL_INVALID, USER_EMAIL_REQUIRED, USER_NAME_REQUIRED } from "../../helpers/validation.messages";

export const CreateCompanySchema = Yup.object({
    name: Yup.string().required(COMPANY_NAME_REQUIRED).trim(),
    contact: Yup.string().required(COMPANY_CONTACT_REQUIRED).trim(),
    email: Yup.string().required(COMPANY_EMAIL_REQUIRED).trim().email(COMPANY_EMAIL_INVALID).matches(EMAIL_REGEX, USER_EMAIL_INVALID),
});

export const CreateUserSchema = Yup.object({
    company: Yup.string().required(USER_NAME_REQUIRED).trim(),
    email: Yup.string().required(USER_EMAIL_REQUIRED).trim().email(USER_EMAIL_INVALID).matches(EMAIL_REGEX, USER_EMAIL_INVALID),
});